import { Input } from 'antd'
import React from 'react'

const SearchField = ({name, placeholder, onChange}) => {
    return (
        <>
            <label className="font-weight-bolder font-size-sm">
                {name}
            </label>
            <div className="input-icon input-icon-right">
                <Input
                    type="text"
                    className="form-control"
                    placeholder={placeholder}
                    onChange={onChange}
                />
                <span>
                    <i className="flaticon2-search-1 icon-md"></i>
                </span>
            </div>
        </>
    )
}

export default SearchField